class Category {
	id
	title
	route
	posts = []

	constructor ({id, title, route}) {
		this.id = id
		this.title = title
		this.route = route
	}

	addPost (post) {
		this.posts.push(post)
	}
}

export { Category }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_posts_loader/entities/Category.js